import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { GroupService, GroupSettingsModel, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';
import  itlocale  from './../../itgridlocale.json';
import { L10n } from '@syncfusion/ej2-base';
import { FileMimeType} from './../general/home/widget-documenti/mimetypes';

L10n.load(itlocale);

@Component({
  selector: 'app-da-approvare',
  templateUrl: './da-approvare.component.html',
  styleUrls: ['./da-approvare.component.css'],
  providers: [DetailRowService,SortService,ToolbarService,GroupService]
})
export class DaApprovareComponent implements OnInit {
  @ViewChild('daApprovaretable') daApprovaretable:any;
  documentPdf:string='';
  showPdf:boolean=false;
  daApprovareList:any=[];
  public groupOptions?: GroupSettingsModel;
  public toolbar: string[];
  public locale: any = "it";
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.toolbar = ['Search'];
    let tic=[];
    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
      this.apiService.get('todo/daapprovare',params).subscribe(data2 => {
        this.daApprovareList=data2.Result;
        this.daApprovaretable.localeObj.currentLocale.EmptyRecord = 'Nessun dato da visualizzare ...'; 
        this.groupOptions = {showDropArea: true, showGroupedColumn:false, columns: ['tipologia'] };
        setTimeout(()=>{

      //    this.daApprovaretable.groupModule.collapseAll();

        },1000);
      
      });
    });
  }
  onLoad() { 
    this.daApprovaretable.localeObj.currentLocale.EmptyRecord = 'Caricamento in corso...'; 
  }
  apridoc(doc){
    if(!doc.type) {
      return;
    }

    let mediaType='';
    Object.entries(FileMimeType).forEach(([key, value]) => {
      if(value.toUpperCase()==doc.type.toUpperCase()){
        mediaType=key;
      }
    });
 
    let loggedUser=JSON.parse(localStorage.getItem('loggedUser'));
    let params={
      id_doc:doc.id,
      id_user:loggedUser.id,
      modulo:doc.modulo
    };
    if(doc.type && doc.type.toUpperCase()=='PDF'){
      this.showPdf=true;
      this.apiService.downloadPDF(params).subscribe(response => {
           mediaType = 'application/pdf';
          var blob = new Blob([response], { type: mediaType });
          const pdfUrl = URL.createObjectURL(blob);
          this.documentPdf=pdfUrl;
      
  
      });
    } else {
      this.apiService.downloadPDF(params).subscribe(response => {
        const blob = new Blob([response],{ type: mediaType });
        const url= window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        let filename=doc.oggetto.trimEnd()+'.'+doc.type;
      
        a.download = filename;
        a.click();
  
        window.URL.revokeObjectURL(url);
        a.remove();
      });
    }
  
   
  }

  scaricaPDF(){
    window.open(this.documentPdf, '_blank');
  }
 
  
  apri(data){
    
    if(data.modulo=='protocolli'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=49','POST',params);
    }
    if(data.modulo=='procedure'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=48','POST',params);
    }
    if(data.modulo=='moduli'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=46','POST',params);
    }
    if(data.modulo=='documenti'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('login/LogonServletAw?oper=1&redirectS=ServletDocumenti','POST',params);
    }
    if(data.modulo=='policy'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=2','POST',params);
    }
    
  }
  
}
